import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { UserInfo, carModel } from '../../shared/class/UserInfo';

import * as Moment from 'moment';

import { Utils } from './@Utils';
import { InputDateTimeContent } from './inputDateTime.component';

@Component({
  selector: 'simple-dialog-content',
  styleUrls: ['simpleDialog.component.scss'],
  template: `
<div class="modal-header">
  <h4 class="modal-title">{{title}}</h4>
  <!-- 
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('cancel')">
    <span aria-hidden="true">&times;</span>
  </button>
  -->
</div>
<div class="card-body">
  <table>
    <tbody>
      <tr><td colspan=2 style="white-space: pre-wrap;">{{message}}</td></tr>
      <tr *ngFor="let inputInfo of inputInfos; let idx = index">
        <td nowrap style="vertical-align:middle">
          <p style="margin: 0px">{{inputInfo.label}}<font color=red size=1 *ngIf="inputInfo.required">*</font></p>
        </td>
        <td *ngIf="inputInfo.inputtype == 'display'">
          <input class="form-control" type="text" name="inputInfo_value" [(ngModel)]="inputInfo.value" size=35 style="background-color: white" readonly>
        </td>
        <td *ngIf="inputInfo.inputtype == 'text'">
          <input class="form-control" type="text" name="inputInfo_value" [(ngModel)]="inputInfo.value" style="background-color: antiquewhite" placeholder={{inputInfo.placeholder}}>
          <font color=red size=1 style="vertical-align:top">{{inputInfo.validateMessage}}</font>
        </td>
        <td *ngIf="inputInfo.inputtype == 'password'">
        <input class="form-control" type="password" name="inputInfo_value" [(ngModel)]="inputInfo.value" style="background-color: antiquewhite" placeholder={{inputInfo.placeholder}}>
        <font color=red size=2 style="vertical-align:top">{{inputInfo.validateMessage}}</font>
        </td>
        <td *ngIf="inputInfo.inputtype == 'textarea'">
          <textarea class="form-control" rows="3" cols="40" name="inputInfo_value" [(ngModel)]="inputInfo.value" style="background-color: antiquewhite" placeholder={{inputInfo.placeholder}}></textarea>
          <font color=red size=1 style="vertical-align:top">{{inputInfo.validateMessage}}</font>
        </td>
        <td *ngIf="inputInfo.inputtype == 'datetimeRange'">
          <input class="form-control" type="text" name="inputInfo_value" [(ngModel)]="inputInfo.value" style="background-color: antiquewhite" placeholder={{inputInfo.placeholder}} (click)="inputDateTimeRange(inputInfo)" readonly="readonly">
          <font color=red size=1 style="vertical-align:top">{{inputInfo.validateMessage}}</font>
        </td>
        <td *ngIf="inputInfo.inputtype == 'select'">
          <select class="form-control" [(ngModel)]="inputInfo.value" style="background-color: antiquewhite">
          <option *ngFor="let type of inputInfo.selectList" value={{type.id}}>
              {{type.name}}
            </option>
          </select>
          <font color=red size=1 style="vertical-align:top">{{inputInfo.validateMessage}}</font>
        </td>
        <td *ngIf="inputInfo.inputtype == 'Noselect'">
        <select class="form-control" [(ngModel)]="inputInfo.value" style="background-color: antiquewhite">
        <option *ngFor="let type of inputInfo.selectList" value={{type.id}}>
            {{type.carnumber}}
          </option>
        </select>
        <font color=red size=1 style="vertical-align:top">{{inputInfo.validateMessage}}</font>
        </td>
        <td *ngIf="inputInfo.inputtype == 'carNoSelect'" colspan="2" style="text-align: center;">
          <span _ngcontent-c3="" (click)="addExpandClass('pages')"><i class="pointer" [ngClass]="pages === 'pages' || pages === '' ? 'fa fa-chevron-down': 'fa fa-chevron-up'" style="color: #fff;background-color: #007bff;border-radius: 0.25rem;padding: 5px;"></i>&nbsp;ナンバー</span>
          <span (click)="addCarInput(carlists)" [class.disabled]="showMenu === 'pages' || showMenu === ''" class="pf"><i _ngcontent-c3="" class="fa fa-plus pointer" style="color: #fff;background-color: #007bff;border-radius: 0.25rem;padding: 5px;"></i></span>
          <span (click)="removeCarInput()" [class.disabled]="showMenu === 'pages' || showMenu === ''" class="pf"><i _ngcontent-c3="" class="fa fa-minus pointer" style="color: #fff;background-color: #E9686B;border-radius: 0.25rem;padding: 5px;"></i></span>
          <div class="nested " [class.expand]="showMenu === 'pages' || showMenu === ''">
            <div class="submenu carContent">
              <div *ngFor="let noList of carlists; let i = index" style="padding-top: 10px;display: flex;">
                <input class="form-control" name="inputInfo_value" [(ngModel)]="noList.carnumber" style="background-color: antiquewhite" placeholder={{noList.carnumber}}>
              </div>
            </div>
          </div>
          <font color=red size=1 style="vertical-align:top">{{inputInfo.validateMessage}}</font>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<div class="modal-footer" *ngIf="button == 'ok'">
  <button class="btn btn-primary"  (click)="clickOK()">OK</button>
</div>
<div class="modal-footer" *ngIf="button == 'okCancel'">
  <button class="btn btn-secondary mr-auto" (click)="activeModal.close('cancel')">キャンセル</button>
  <button class="btn btn-primary"  (click)="clickOK()">OK</button>
</div>
`
})
export class SimpleDialogContent {
  @Input() title;
  @Input() message;
  @Input() confirmMessage;
  @Input() button;
  @Input() inputInfo;
  @Input() inputInfos;
  showMenu: string = '';
  pages = 'pages';
  carlists: carModel[];
  carlistsOld: carModel[];

  constructor(public activeModal: NgbActiveModal, private modalService: NgbModal) { }

  ngOnInit() {
    if (this.inputInfos != undefined && this.inputInfos.length == 6 && this.inputInfos[4].inputtype == 'carNoSelect' && this.inputInfos[4].selectList != undefined) {
      this.carlists = this.inputInfos[4].selectList;
      this.carlistsOld = this.inputInfos[4].selectList.filter(item => item.id !== 0);
    }
  }

  private async clickOK() {
    // 入力チェック
    if (this.validation() == false) return;

    // 確認ダイアログの表示
    if (this.confirmMessage != null) {
      const modalRef = this.modalService.open(SimpleDialogContent);
      const component = modalRef.componentInstance as SimpleDialogContent;
      component.title = "確認";
      component.button = "okCancel";
      component.message = this.confirmMessage;

      const result = await modalRef.result;
      if (result != "ok") {
        this.carlists = this.carlistsOld;
        // selectListがない場合を考慮
        try {
          this.inputInfos[4].selectList = this.carlists.filter(item => item.id !== 0);
        } catch{ }
      } else {
        // selectListがない場合を考慮
        try {
          this.inputInfos[4].selectList = this.carlists;
        } catch{ }
      }
      if (result != "ok") return;
    }

    this.activeModal.close('ok');

  }

  // ナンバー一覧展開
  addExpandClass(element: any) {
    if (element === this.showMenu) {
      this.showMenu = '0';
      this.pages = '0';
    } else {
      this.showMenu = element;
      this.pages = element;
    }

  }
  // ナンバー追加
  addCarInput(list) {
    if (list.length < 10) {
      let newCar = {
        id: 0,
        carnumber: "",
      }
      this.carlists.push(newCar);
    }
  }
  // ナンバー削除
  removeCarInput() {
    this.carlists = this.carlists.filter(item => item.id !== 0);
  }
  // reset() {
  //   if (this.inputInfos[4].selectList != undefined && this.inputInfos[4].inputtype == 'carNoSelect') {
  //     if (this.carlists.length > this.carlistsOld.length) {
  //       this.inputInfos[4].selectList = this.carlists.filter(item => item.id !== 0);
  //     }
  //   }
  // }

  // 入力チェック
  private validation(): boolean {
    var ret = true;

    if (this.inputInfos != undefined) {
      for (var i = 0; i < this.inputInfos.length; i++) {
        this.inputInfos[i].validateMessage = "";
        if (this.inputInfos[i].required == true
          && (this.inputInfos[i].value == "" || this.inputInfos[i].value == undefined)) {
          this.inputInfos[i].validateMessage = "入力必須です。";
          ret = false;
        }
      }
    }
    return ret;
  }

  // 時間設定
  async inputDateTimeRange(inputInfo: any) {
    // 予約時間設定ダイアログの表示
    const modalRef = this.modalService.open(InputDateTimeContent);
    const component = modalRef.componentInstance as InputDateTimeContent;
    component.title = "予約時間設定";
    component.inputDateTime1 = Utils.convertDateTime1(inputInfo.value);
    component.inputDateTime2 = Utils.convertDateTime2(inputInfo.value);

    const result = await modalRef.result;
    if (result != "ok") return;

    //3か月以上先の予約かどうか判定する変数
    let checkDate1 = new Date();
    checkDate1.setMonth(checkDate1.getMonth() + 3);
    //現在より前の時間を設定していないか判定する関数
    let checkDate2 = new Date();
    if (component.inputDateTime1 > checkDate1) {
      const modalRef = this.modalService.open(SimpleDialogContent);
      const component = modalRef.componentInstance as SimpleDialogContent;
      component.title = "予約変更エラー";
      component.message = "3か月以上先の予約はできません。";
      component.button = "ok";
      const result = await modalRef.result;
      if (result == "ok") {
        this.inputDateTimeRange(inputInfo);
      }
      return;
    }
    if (component.inputDateTime1 < checkDate2) {
      const modalRef = this.modalService.open(SimpleDialogContent);
      const component = modalRef.componentInstance as SimpleDialogContent;
      component.title = "予約変更エラー";
      component.message = "現在より前の時間は設定できません。";
      component.button = "ok";
      const result = await modalRef.result;
      if (result == "ok") {
        this.inputDateTimeRange(inputInfo);
      }
      return;
    }
    inputInfo.value = Utils.DateTimeDisp(component.inputDateTime1, component.inputDateTime2);
  }
}
